exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n@keyframes spin-data-v-35704766 {\n0% {\r\n    transform: rotate(0deg) scaleX(-1);\n}\n100% {\r\n    transform: rotate(360deg) scaleX(-1);\n}\n}\n.spinning[data-v-35704766] {\r\n  animation: spin-data-v-35704766 2s linear infinite;\n}\r\n", ""]);

// exports
